//request.js
import axios from 'axios'
//根据命令启动不同的开发环境
const isDev = process.env.NODE_ENV === 'development'

//var  apiurl = 'http://' + (window.prodAPI || '39.106.44.187:8899') + '/api';
const request = axios.create({
  // 根据环境 设置不同的baseURL
//  baseURL: isDev ? 'http://192.168.110.16:8888/' : 'http://39.101.166.52:8888/'
  baseURL: isDev ? 'http://39.101.166.52:8888/' : 'http://39.101.166.52:8888/'
  //baseURL: isDev ? apiurl :apiurl
})

// 请求拦截器
request.interceptors.request.use((config) => {
 
  // console.log('正在加载....')
  return config
}, (error) => {
  return Promise.reject(error)
})

// 响应拦截器 --- 所有请求的相应先到此处
request.interceptors.response.use((response) => {
  // console.log('加载完毕')
  return response
}, (error) => {
  return Promise.reject(error)
})
export default request


// WEBPACK FOOTER //
// ./src/request/request.js